export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-dispatch/index.js
// module id = 20
// module chunks = 0 1 2 3 4